import UIHelper from 'general/helpers/UIHelper';
import useRouter from 'hooks/useRouter';
import MaintainerDetailView from '../../components/MaintainerDetailView';

MaintainerDetailScreen.propTypes = {};

function MaintainerDetailScreen(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const { isMaintainerInfo = false } = props;
    const maintainerId = router.query?.maintainerId;

    return (
        <div>
            {/* breadcrumb */}
            {!isMaintainerInfo && (
                <div>
                    {UIHelper.buildBreadcrumb([
                        {
                            title: 'Danh sách kỹ thuật viên',
                            onPress: () => {
                                router.navigate(-1);
                            },
                        },
                        { title: 'Chi tiết kỹ thuật viên' },
                    ])}
                </div>
            )}
            <div className="my-4">
                <MaintainerDetailView maintainerId={maintainerId} isMaintainerInfo={isMaintainerInfo} />
            </div>
        </div>
    );
}

export default MaintainerDetailScreen;
